var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoframe"},[_c('youtube',{attrs:{"video-id":"i_UEIX9ENUM","height":"600","width":"800","player-vars":{ autoplay: 1 }},on:{"ended":function($event){return _vm.fimVideo()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }